<app-work-view
  class="block lg:-mt-[60px]"
  [userId]="(orgaUserId | async)!"
  [showFilter]="['project', 'position']"
></app-work-view>
